import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    evento: '',

    id: 0,
    fechaInicio: moment(new Date()).format('YYYY-MM-DD'),
    fechaFin: moment(new Date()).format('YYYY-MM-DD'),
    nombre: '',
    rowVersion: null,

    eventoEtapaDatos: []
};

const mutations = {
    updateField,

    'INICIALIZAR_EVENTO_ETAPA' (state, params) {
        state.eventoId = params.eventoId;
        state.evento = '';

        state.id = params.eventoEtapaId;
        state.fechaInicio = moment(new Date()).format('YYYY-MM-DD'),
        state.fechaFin = moment(new Date()).format('YYYY-MM-DD'),
        state.nombre = '';
        state.rowVersion = null;
    },
    'SET_EVENTO' (state, evento) {
        state.evento = evento.nombre.trim();
    },
    'SET_EVENTO_ETAPA' (state, eventoEtapa) {
        state.fechaInicio = moment(eventoEtapa.fechaInicio).format('YYYY-MM-DD');
        state.fechaFin = moment(eventoEtapa.fechaFin).format('YYYY-MM-DD');
        state.nombre = eventoEtapa.nombre.trim();
        state.rowVersion = eventoEtapa.rowVersion;
    },

    'INICIALIZAR_DATOS' (state) {
        state.eventoEtapaDatos = [];
    },
    'SET_DATOS' (state, eventoEtapaDatos) {
        state.eventoEtapaDatos = eventoEtapaDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVENTO_ETAPA', params);

            let getEtapa = false;
            if (params) {
                if (params.eventoEtapaId) {
                    if (params.eventoEtapaId != 0) {
                        getEtapa = true;
                    }
                }
            }

            if (getEtapa) {
                /* Recuperamos los datos del evento */
                apiAxios.get('eventos/' + params.eventoId) 
                    .then(res => {
                        commit('SET_EVENTO', res.data);
                        /* Recuperamos los datos del participante */
                        return apiAxios.get('eventos/' + params.eventoId + '/etapas/' + params.eventoEtapaId + '/abm');
                    })
                    .then(res => {
                        commit('SET_EVENTO_ETAPA', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else {
                /* Recuperamos los datos del evento */
                apiAxios.get('eventos/' + params.eventoId) 
                    .then(res => {
                        commit('SET_EVENTO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                let eventoEtapa= {
                    fechaInicio: moment(state.fechaInicio).format('YYYY-MM-DD'),
                    fechaFin: moment(state.fechaFin).format('YYYY-MM-DD'),
                    nombre: state.nombre.toUpperCase().trim(),
                };

                let url = 'eventos/' + state.eventoId + '/etapas';
                if (state.id != 0) {
                    url += '/' + state.id;
                    eventoEtapa.rowVersion = state.rowVersion;
                }

                apiAxios.post(url, eventoEtapa)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },

    getDatos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (params) {
                apiAxios.get('eventos/' + params.eventoId + '/etapas/' + params.eventoEtapaId ) 
                    .then(res => {
                        let eventoEtapaDatos = [
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'fechaInicio', 'campo': 'Fecha de Inicio', 'valor': res.data.fechaInicio, 'formato': 'fecha' },
                            { 'nombre': 'fechaFin', 'campo': 'Fecha de Finalización.', 'valor': res.data.fechaFin, 'formato': 'fecha' },
                        ]
                                      
                        commit('SET_DATOS', eventoEtapaDatos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}